import styled from 'styled-components';

const LeaderboardItemScore = styled.h4`
  margin-top: 12px;
`;

export default LeaderboardItemScore;
